export enum ResultMode {
  Alpha = 1,
  Numeric = 2,
  Open= 3,
  Titer = 4,
  CutOff = 5,
  None = 6
}
